import React from "react";
import "./Preloader.scss";

function Preloader() {
  return (
    <div className="preloader">
      <div className="spinner"></div>
    </div>
  );
}

export default Preloader;
